import { lazy } from 'react';
import { Navigate } from 'react-router-dom';

const UploadInvoice = lazy(() => import('../../../../pages').then(module => ({ default: module.UploadInvoice })));

export const currentAccountChildrenRoutes = [
  {
    path: 'carga-de-factura',
    element: <UploadInvoice title='Presentación Factura Comisiones' />,
  },
  {
    path: '',
    element: (
      <Navigate to='/cuenta-corriente/facturas-pendientes/carga-de-factura' />
    ),
  },
];
